import React from 'react';
import ReactDOM from 'react-dom/client';

import { createBrowserRouter, RouterProvider } from "react-router-dom";

import "./index.css";
import Home from "./Home";
import Trade from "./Trade";
import TradeProcessWrapper from "./TradeProcessWrapper";
import TradeCreate from "./TradeCreate";

const root = ReactDOM.createRoot(document.getElementById("root"));

const router = createBrowserRouter([
  {
    path: "/",
    element: <Home />
  },
  {
    path: "/trade/start/:bookID/mail",
    element: <TradeProcessWrapper method="mail" />
  },
  {
    path: "/trade/start/:bookID/buy",
    element: <TradeProcessWrapper method="buy" />
  },
  {
    path: "/trade/c/:type/:givingBookID/:receivingBookID/:tradeID/:sessionID",
    element: <TradeCreate />
  },
  {
    path: "/trade/start/:bookID",
    element: <Trade />
  }
], {
  basename: "/foreword"
});

root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
    <div className="Logo">
      <img alt="Hello, Sincerely," src="/foreword/images/logo-white-transparent.png" />

      <div className="footer">
        A project by Hello, Sincerely, in New York City. Find us <a href="https://www.instagram.com/hellosincerely">@hellosincerely</a>
      </div>
    </div>
  </React.StrictMode>
);
